"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoutableContainer_1 = require("./RoutableContainer");
exports.default = RoutableContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableContainer/index.js
// module id = 1006
// module chunks = 8